import HomeIcon from 'src/assets/images/sidebar-icons/home-icon.svg'
import ProfileIcon from 'src/assets/images/sidebar-icons/profile-icon.svg'
import SettingsIcon from 'src/assets/images/sidebar-icons/settings-icon.svg'
export const navigationLinks = [
  { title:"Home", url:"/", icon: HomeIcon },
  { title:"My profile", url:"/profile", icon: ProfileIcon },
  { title:"Workflow", url:"/workflow", icon: SettingsIcon, role: ['teacher', 'mentor', 'administrator', 'lecturer', 'researcher'] },
  { title:"Analytic", url:"/analytics", icon: SettingsIcon, role: ['administrator'] },
]
